module.exports = __webpack_public_path__ + "img/CBD-Salve-150mg.da291fa3.jpg";